import React from 'react';
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Notification } from '../../types/Notification';

interface UnknownProps {
  notification: Notification
}

const Unknown: React.FC<UnknownProps> = ({ notification }) => {

  return (
    <Card className="mt-4">
      <CardHeader>
        <CardTitle>{notification.subject}</CardTitle>
      </CardHeader>
    </Card>
  );
};

export default Unknown;